import { bluonColors } from './colors';

export const MuiIconButtonThemeVariants = [
  {
    props: { color: 'primary' },
    style: {
      '&:hover': {
        backgroundColor: bluonColors.blue[50],
      },
    },
  },
  {
    props: { color: 'secondary' },
    style: {
      color: bluonColors.navy[500],
      '&:hover': {
        backgroundColor: bluonColors.navy[50],
      },
    },
  },
  {
    props: { color: 'error' },
    style: {
      color: bluonColors.tomato[500],
      '&:hover': {
        backgroundColor: bluonColors.tomato[100],
      },
    },
  },
  {
    props: { color: 'success' },
    style: {
      color: bluonColors.green[500],
      '&:hover': {
        backgroundColor: bluonColors.green[50],
      },
    },
  },
  {
    props: { color: 'default' },
    style: {
      color: bluonColors.grey[700],
      '&:hover': {
        backgroundColor: bluonColors.grey[100],
      },
      '&:focus': {
        backgroundColor: bluonColors.grey[300],
      },
    },
  },
  {
    props: { color: 'iconMirrorPrimary' },
    style: {
      backgroundColor: bluonColors.blue[500],
      '&:hover': {
        backgroundColor: bluonColors.blue[700],
      },
    },
  },
];

export const MuiIconButtonTheme = {
  styleOverrides: {
    root: {
      borderRadius: 100,
      '&.Mui-disabled': {
        '.MuiSvgIcon-root': {
          color: bluonColors.grey[500],
        },
      },
      '&:focus': {
        outline: 'none',
      },
    },
  },
  variants: MuiIconButtonThemeVariants,
};
